import { DefaultFieldDefinitionClientLogic } from "./default-field-def-client-logic";
import { FormField } from '../form-field.model';

export class ContactsFieldDefLogic extends DefaultFieldDefinitionClientLogic {



    public getDisplayValueForFormsGridRow(row: object, columnDef: FormField) {
        let name: string = columnDef.name.toLowerCase();
        if (columnDef.name == 'contactemaildonotedit') {
            return `<a class="contact-email-column-in-forms-grid" href="mailto:${row[columnDef.name]}">${row[columnDef.name]}</a>`;
        }
    }

    public includeInFormTemplateInstancesGrid(): boolean {
        return true;
    }

    public isATypeOfGridField(formField: FormField): boolean {
        return true;
    }

    public isDataGrid(): boolean {
        return true;
    }
}
